import { createStorePersist, RequestStatus, } from "common-frontend-components";
import { getStorageCall } from '@yehonadav/safestorage';
import { useEffect } from "react";
import { enablePersistentCache } from "../../utils/enablePersistentCache";
import { callGetSitePhotosByGroupAsync } from "../../apis/sitePhotos";
import { sortAppConfigItems } from "../../utils/sortAppConfigItems";
const groupName = 'global/*';
const persistOptions = {
    name: `site-config/${groupName}`,
    whitelist: ["data", "cache", "groupConfig", "components"],
    getStorage: getStorageCall,
};
const getDefaultValues = () => ({
    data: [],
    components: {},
    status: RequestStatus.pending,
});
const { get, set, useStore, fetchStore } = createStorePersist({
    persistOptions,
    persistAfterClearingStorage: false,
    getDefaultValues,
});
// ensure cache is a date
enablePersistentCache(get);
const useStatus = () => useStore(fetchStore.status);
export const globalAppConfigStore = {
    useLoad: () => {
        const status = useStatus();
        const data = globalAppConfigStore.getData();
        useEffect(() => {
            if (get().status !== RequestStatus.pending)
                return;
            const { cache, groupConfig } = get();
            if (cache !== undefined && cache.getTime() + (groupConfig?.params?.cacheSeconds || 0) * 1000 > Date.now())
                return set({ status: RequestStatus.loaded });
            set({ status: RequestStatus.loading });
            callGetSitePhotosByGroupAsync(groupName)
                .then(data => {
                const config = data.find(i => i.params?.component === "group-config");
                const filteredData = sortAppConfigItems(data
                    .filter(i => i.params?.component !== 'group-config'), config);
                set({
                    data: filteredData,
                    groupConfig: config,
                    components: filteredData.reduce((components, i) => (components[i.params?.component] = i,
                        components), {}),
                    cache: typeof config?.params?.cacheSeconds === 'number' ? new Date() : undefined,
                    status: RequestStatus.loaded,
                });
            })
                .catch(() => set({ status: RequestStatus.failed }));
        }, [status]);
        return { status, data };
    },
    useData: () => useStore(s => s.data),
    useStatus,
    useCache: () => useStore(s => s.cache),
    useComponent: (component) => useStore(s => s.components[component]),
    getData: () => get().data,
    getStatus: () => get().status,
    getCache: () => get().cache,
    getComponent: (component) => get().components[component],
};
//# sourceMappingURL=globalAppConfigStore.js.map